import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15851136"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "py-4 px-lg-5 px-3" }
const _hoisted_2 = { class: "fw-bold" }
const _hoisted_3 = { class: "mt-3 box_container" }
const _hoisted_4 = { class: "fw-bold" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "fw-bold mb-lg-3 mb-2" }, "Pending Evaluations", -1))
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-6 mb-2" }
const _hoisted_8 = { class: "card border-0 shadow" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, "Health Needs", -1))
const _hoisted_10 = {
  key: 0,
  class: "card-body list"
}
const _hoisted_11 = {
  key: 1,
  class: "px-3"
}
const _hoisted_12 = {
  key: 2,
  class: "card-body list"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "border-0 h-75 d-flex align-items-center justify-content-center" }, " No pending evaluations ", -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "col-md-6" }
const _hoisted_16 = { class: "card border-0 shadow" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, "Innovations", -1))
const _hoisted_18 = {
  key: 0,
  class: "card-body list"
}
const _hoisted_19 = {
  key: 1,
  class: "px-3"
}
const _hoisted_20 = {
  key: 2,
  class: "card-body list"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "border-0 h-75 d-flex align-items-center justify-content-center" }, " No pending evaluations ", -1))
const _hoisted_22 = [
  _hoisted_21
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_EvaluateHealthNeed = _resolveComponent("EvaluateHealthNeed")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_EvaluateInnovation = _resolveComponent("EvaluateInnovation")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h5", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createElementVNode("section", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headerData, (item, i) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "bx text-center",
          key: i
        }, [
          _createElementVNode("h1", _hoisted_4, _toDisplayString(item.value), 1),
          _createElementVNode("p", null, _toDisplayString(item.title), 1)
        ]))
      }), 128))
    ]),
    _createElementVNode("section", null, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            (!_ctx.needLoading && _ctx.getHealthNeeds.length > 0)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getHealthNeeds, (item, i) => {
                    return (_openBlock(), _createElementBlock("li", { key: i }, [
                      _createElementVNode("span", null, _toDisplayString(item?.title), 1),
                      _createVNode(_component_Button, {
                        onClick: ($event: any) => (_ctx.gotoEvaluateNeed(item.id)),
                        label: "Evaluate",
                        class: "p-button-sm p-button-primary py-2",
                        "aria-label": "Evaluate Need"
                      }, null, 8, ["onClick"])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_ctx.needLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
                    return _createVNode(_component_Skeleton, {
                      width: "100%",
                      height: "3rem",
                      class: "mb-3",
                      key: i
                    })
                  }), 64))
                ]))
              : _createCommentVNode("", true),
            (!_ctx.needLoading && _ctx.getHealthNeeds.length === 0)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_12, _hoisted_14))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            (!_ctx.innovationLoading && _ctx.getInnovations.length > 0)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_18, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getInnovations, (item, i) => {
                    return (_openBlock(), _createElementBlock("li", { key: i }, [
                      _createElementVNode("span", null, _toDisplayString(item?.solution_title), 1),
                      _createVNode(_component_Button, {
                        onClick: ($event: any) => (_ctx.gotoEvaluateInnovation(item.id)),
                        label: "Evaluate",
                        class: "p-button-sm p-button-primary py-2",
                        "aria-label": "Evaluate Innovation"
                      }, null, 8, ["onClick"])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_ctx.innovationLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
                    return _createVNode(_component_Skeleton, {
                      width: "100%",
                      height: "3rem",
                      class: "mb-3",
                      key: i
                    })
                  }), 64))
                ]))
              : _createCommentVNode("", true),
            (!_ctx.innovationLoading && _ctx.getInnovations.length === 0)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_20, _hoisted_22))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createVNode(_component_Dialog, {
      visible: _ctx.healthNeedDialog,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.healthNeedDialog) = $event)),
      style: { width: '70rem' },
      header: "Evaluate Health Needs",
      modal: true,
      dismissableMask: true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_EvaluateHealthNeed, {
          EvaluateId: _ctx.id,
          modal: true,
          onClose: _ctx.closeHealthNeedDialog
        }, null, 8, ["EvaluateId", "onClose"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      visible: _ctx.innovationDialog,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.innovationDialog) = $event)),
      style: { width: '70rem' },
      header: "Evaluate Innovations",
      modal: true,
      dismissableMask: true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_EvaluateInnovation, {
          EvaluateId: _ctx.id,
          modal: true,
          onClose: _ctx.closeInnovationDialog
        }, null, 8, ["EvaluateId", "onClose"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}